<template>
  <div class="toggle-button-with-label">
    <label class="toggle-button">
      <input
        type="checkbox"
        v-model="localValue"
      />
      <span class="slider"></span>
    </label>
    <!-- Affiche le texte si la prop 'label' est définie -->
    <span class="toggle-button-text" v-if="label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "ToggleButton",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // Nouveau prop pour afficher un texte à droite
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
        this.$emit("change", newValue);
      }
    }
  }
};
</script>

<style scoped>
/* Le conteneur principal pour le bouton + texte */
.toggle-button-with-label {
  display: inline-flex;
  align-items: center;
}

.toggle-button {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  margin-right: 8px; /* Espace entre le bouton et le label */
  padding: 0;
}

/* Cache l'input natif */
.toggle-button input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Slider qui se déplace à gauche/droite */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0; 
  left: 0;
  right: 0; 
  bottom: 0;
  background-color: #ccc;
  border-radius: 34px;
  transition: 0.4s;
}

/* Le petit rond à l'intérieur */
.slider::before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}

/* Quand c'est activé, on change la couleur du background */
input:checked + .slider {
  background-color: #7ab228;
}

/* Quand c'est activé, on déplace le rond à droite */
input:checked + .slider:before {
  transform: translateX(24px);
}

/* Style du texte à droite du bouton */
.toggle-button-text {
  font-size: 14px;
  color: #333;
}
</style>
